import { __assign } from "tslib";
import React, { useContext, useMemo } from 'react';
import styledError from '../utils/error';
import isFunction from '../utils/isFunction';
export var ThemeContext = React.createContext(undefined);
export var ThemeConsumer = ThemeContext.Consumer;
function mergeTheme(theme, outerTheme) {
    if (!theme) {
        throw styledError(14);
    }
    if (isFunction(theme)) {
        var themeFn = theme;
        var mergedTheme = themeFn(outerTheme);
        if (process.env.NODE_ENV !== 'production' &&
            (mergedTheme === null || Array.isArray(mergedTheme) || typeof mergedTheme !== 'object')) {
            throw styledError(7);
        }
        return mergedTheme;
    }
    if (Array.isArray(theme) || typeof theme !== 'object') {
        throw styledError(8);
    }
    return outerTheme ? __assign(__assign({}, outerTheme), theme) : theme;
}
/**
 * Returns the current theme (as provided by the closest ancestor `ThemeProvider`.)
 *
 * If no `ThemeProvider` is found, the function will error. If you need access to the theme in an
 * uncertain composition scenario, `React.useContext(ThemeContext)` will not emit an error if there
 * is no `ThemeProvider` ancestor.
 */
export function useTheme() {
    var theme = useContext(ThemeContext);
    if (!theme) {
        throw styledError(18);
    }
    return theme;
}
/**
 * Provide a theme to an entire react component tree via context
 */
export default function ThemeProvider(props) {
    var outerTheme = React.useContext(ThemeContext);
    var themeContext = useMemo(function () { return mergeTheme(props.theme, outerTheme); }, [props.theme, outerTheme]);
    if (!props.children) {
        return null;
    }
    return React.createElement(ThemeContext.Provider, { value: themeContext }, props.children);
}
//# sourceMappingURL=ThemeProvider.js.map